module.exports = __webpack_public_path__ + "img/goggles_TH.ecd578fe.png";